import eventMock from "@/mock/evenement.json";
import {evenement} from "@/types/evenement";

import {getDataMock} from "./_callApi";

export async function getEvenement(): Promise<evenement[]> {
  if (getDataMock()) {
    const event: evenement[] = eventMock;
    return event;
  } else {
    const event: evenement[] = eventMock;
    return event;
  }
}
